var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalWorkflows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_021---Tick-File",
    "data-name": "021---Tick-File",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 44.917 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M44.917,4.052A4.027,4.027,0,0,0,40.925,0H8.992A4.027,4.027,0,0,0,5,4.052V32.414a.8.8,0,1,0,1.6,0V4.052A2.413,2.413,0,0,1,8.992,1.621H40.925a2.413,2.413,0,0,1,2.4,2.431v31.6H37.732a4.027,4.027,0,0,0-3.992,4.052v5.672H18.572a.81.81,0,0,0,0,1.621H34.538a.792.792,0,0,0,.564-.237l9.58-9.724a.817.817,0,0,0,.234-.573ZM37.732,37.276h4.459l-6.854,6.958V39.707A2.413,2.413,0,0,1,37.732,37.276Z",
    fill: "#96006b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,44.794a3.366,3.366,0,0,0,.993,2.4l6.781,6.781a3.372,3.372,0,0,0,2.4.993,2.282,2.282,0,0,0,.273-.011,3.384,3.384,0,0,0,2.478-1.4L28.178,32.366a3.39,3.39,0,1,0-5.5-3.962l-1.07,1.486a.848.848,0,1,0,1.376.99l1.07-1.485a1.7,1.7,0,1,1,2.751,1.98L11.546,52.564a1.688,1.688,0,0,1-1.237.7,1.709,1.709,0,0,1-1.337-.491L2.192,45.992a1.7,1.7,0,0,1,0-2.4,1.735,1.735,0,0,1,2.4,0l4.667,4.666a.837.837,0,0,0,.668.246.848.848,0,0,0,.619-.349l10-13.887a.848.848,0,1,0-1.376-.99L9.747,46.358,5.788,42.4a3.475,3.475,0,0,0-4.795,0A3.366,3.366,0,0,0,0,44.794Z",
    transform: "translate(0 -5.964)",
    fill: "#f48116"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M48,6H18a1,1,0,0,0,0,2H48a1,1,0,0,0,0-2Z",
    transform: "translate(-8.175 -1)",
    fill: "#ff0185"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M14,12H12a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z",
    transform: "translate(-2.175 -2.276)",
    fill: "#ff0185"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M17.911,14H38.873a1,1,0,0,0,0-2H17.911a1,1,0,0,0,0,2Z",
    transform: "translate(-2.714 -2.276)",
    fill: "#ff0185"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M14,18H12a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z",
    transform: "translate(-2.175 -3.551)",
    fill: "#ff0185"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M18,20H34a1,1,0,0,0,0-2H18a1,1,0,0,0,0,2Z",
    transform: "translate(-2.633 -3.551)",
    fill: "#ff0185"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M51,20.783a1.03,1.03,0,0,0-2,0V31.743a1.03,1.03,0,0,0,2,0Z",
    transform: "translate(-10.083 -3.526)",
    fill: "#ff0185"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M50,38a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V39A1,1,0,0,0,50,38Z",
    transform: "translate(-10.083 -7.464)",
    fill: "#ff0185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalWorkflows);
export default __webpack_public_path__ + "static/media/ApprovalWorkflows.24f3f05bdca49dc645e7591d58a424e5.svg";
export { ForwardRef as ReactComponent };